import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { FpUserPropertiesDto } from 'webcommon/shared';
import { FpMessagesRepository } from 'webcommon/webapi';

@Injectable()
export class FpUserSettingsService {
  constructor(
    private messagesRepository: FpMessagesRepository,
  ) {}

  private fpUserProperties$ = this.messagesRepository.getFacilityPortalUserProperties().pipe(
    shareReplay({ bufferSize: 1, refCount: false }),
  );

  getFpUserProperties(): Observable<FpUserPropertiesDto> {
    return this.fpUserProperties$;
  }
}
